module.exports = __webpack_public_path__ + "static/media/azure.f548d3f1.svg";